import React from "react";
import style from "./NotFound.module.css"

const NotFound = () => {
    return(
        <div className={style.screen}>
            <h1>Not Found</h1>
        </div>
    )
}

export default NotFound;